export default __webpack_public_path__ + "static/media/N3285R-Outside.39be655d.png";